import icons from "./icons";
import sounds from "./sounds";

export default {
  sounds,
  icons,
};
